<ng-container *ngIf="launchText.length > 0">
    <p class="onboarding-launcher" [class.onboarding-rerun]="setupRuns > 0"><a class="btn" (click)="showOnboarding = true">{{launchText}}</a></p>
</ng-container>
<ng-container *ngIf="showOnboarding">
    <acabim-modal
            [title]="'Setup wizard'"
            [fullPage]="true"
            (status)="handleOnboardingModal($event)"
            [display]="showOnboarding">
        <acabim-admin-onboarding-step-wrapper (submit)="completed($event)"></acabim-admin-onboarding-step-wrapper>
    </acabim-modal>
</ng-container>
